"use strict";

exports.__esModule = true;
exports.StyledInputGroup = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const maxHeight = "50px";
const StyledInputGroup = _styledComponents.default.div`
  display: flex;
  align-items: center;

  label {
    background: ${({
  theme
}) => theme.colors.lightGrey};
    color: ${({
  theme
}) => theme.colors.blacks[10]};
    // max-height: ${maxHeight};
    padding: 15px 14px 14px 14px;
    margin: 0 -3px 0 0;
    z-index: 1;
    border-top: 1px solid ${({
  theme
}) => theme.colors.lightGrey};
    border-right: 1px solid ${({
  theme
}) => theme.colors.lightGrey};
    border-bottom: 1px solid ${({
  theme
}) => theme.colors.lightGrey};
    border-left: 1px solid ${({
  theme
}) => theme.colors.lightGrey};
    border-top-left-radius: ${({
  theme
}) => theme.borderRadius.small};
    border-bottom-left-radius: ${({
  theme
}) => theme.borderRadius.small};
    height: 50px;
  }

  > div {
    display: flex;
    flex: 1 1 auto;
    width: auto;

    &:last-child {
      button {
        min-height: ${maxHeight};
        display: flex;
        flex: 0 0 auto;
        width: auto;
        margin-bottom: 0;
      }
    }

    // Legacy support for Dropdown component
    select {
      width: 100%;
      max-height: ${maxHeight};
      border: 1px solid ${({
  theme
}) => theme.colors.select.border};
    }
  }

  input {
    max-height: ${maxHeight};
    height: 50px;
  }

  select {
    width: 100%;
    max-height: ${maxHeight};
    height: 50px;
  }

  button {
    display: flex;
    flex: 0 0 auto;
    width: auto;
    min-height: 0;
    margin-left: -3px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    height: 50px;
  }

  ${_styledSystem.space}
  ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.position}
`;
exports.StyledInputGroup = StyledInputGroup;